export default __webpack_public_path__ + "assets/images/7a7d8eff9d5f1c835a6cf04ee5b145da.jpg";